<h1 mat-dialog-title class="!text-xl !font-medium">{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
